<section class="flex w-screen min-h-[100dvh] m-0 p-0 bg-[#F8F9FA]">
  <div
    id="main-content"
    class="flex w-full min-h-full justify-center items-start mx-auto no-scrollbar overflow-y-auto"
  >
    <router-outlet />
  </div>
</section>
